import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ChangeDetectionStrategy,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  AbstractControl,
} from "@angular/forms";
import { NzTreeComponent } from "ng-zorro-antd/tree";
import { NzFormatEmitEvent, NzTreeNodeOptions } from "ng-zorro-antd/core";
import {
  FieldWrapper,
  KreFormFieldConfig,
  KreTableFieldConfig,
} from "@kre-form/core";

import * as _ from "lodash";
import { DataService } from "../../service/data.service";

import {
  ISelectedNode,
  IOrgData,
  ITreeData,
  ICheckedTree,
} from "../../tools/util";

@Component({
  selector: "kreform-employee",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  providers: [DataService],
})
export class KreFormEmployee implements OnInit {
  @Input() fieldConfig: KreFormFieldConfig = {};

  constructor(public dataService: DataService) {}

  selectData: ICheckedTree[] = [];
  get selectedNode() {
    return _.cloneDeep(this.selectData);
  }

  tag: boolean = true;

  //是否要多选
  check = false;

  //是否有操作列0 没有操作列；1 多个操作按钮 2 选择
  action = 0;

  //table 头部信息
  header: any[] = [
    { key: "id", name: "id", hiden: true },
    { key: "code", name: "工号", width: 150 },
    { key: "name", name: "姓名", width: 150 },
    { key: "organization", name: "部门" },
  ];

  //table 行数据
  body: any[] = [];

  buttonlist: any[] = [];

  checkid: any[] = [];

  query = {
    total: 0,
    pageIndex: 1,
    pageSize: 15,
    sortName: "",
    sortValue: "",
    keyWord: "",
  };

  get selectType() {
    let res = "";
    if (
      this.fieldConfig != undefined &&
      this.fieldConfig != null &&
      this.fieldConfig.templateOptions != undefined &&
      this.fieldConfig.templateOptions != null &&
      this.fieldConfig.templateOptions.selectType != undefined
    ) {
      res = this.fieldConfig.templateOptions.selectType;
    }
    return res;
  }

  getSelectData() {
    if (
      this.fieldConfig != null &&
      this.fieldConfig.model != undefined &&
      this.fieldConfig.model != null &&
      this.fieldConfig.key != undefined &&
      this.fieldConfig.key != null &&
      this.fieldConfig.model[this.fieldConfig.key] != undefined &&
      this.fieldConfig.model[this.fieldConfig.key] != null
    ) {
      this.selectData = _.cloneDeep(
        this.fieldConfig.model[this.fieldConfig.key]
      );
    }

    if (this.selectData != null && this.selectData.length > 0) {
      this.checkid = this.selectData.map((item) => {
        return {
          id: item.value,
          name: item.label,
        };
      });
    } else {
      this.checkid = [];
    }
  }

  ngOnInit() {
    if (this.selectType == "multiple") {
      this.check = true;
      this.action = 0;
    }
    if (this.selectType == "single") {
      this.check = false;
      this.action = 2;
      this.header.push({
        key: "action",
        name: "操作",
        hiden: true,
        action: true,
      });
    }
    this.getEmployeeData();
  }

  ngOnChanges(changes: SimpleChanges) {}

  getEmployeeData() {
    this.dataService
      .getSysCtrEmployee({
        keyWord: this.query.keyWord,
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize,
      })
      .subscribe((res: any) => {
        this.query.pageIndex = res.index;
        this.query.total = res.total;
        this.body = res.data;
      });

    this.getSelectData();
  }

  pageIndexChange(event: any) {
    this.dataService
      .getSysCtrEmployee({
        keyWord: this.query.keyWord,
        pageIndex: this.query.pageIndex,
        pageSize: this.query.pageSize,
      })
      .subscribe((res: any) => {
        this.query.pageIndex = event.pageIndex;
        this.query.total = res.total;
        this.body = res.data;
      });
  }

  checkChange(list: any[]) {
    if (list != null && list.length > 0) {
      this.selectData = list.map((item) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    } else {
      this.selectData = [];
    }
  }
}
